/**
 * Google Analytics (GA4).
 *
 * Lastes aldri av seg selv. Skriptet hentes foerst naar den besoekende har
 * trykket «Godta alle» i samtykkebanneret, fordi Analytics setter
 * informasjonskapsler (_ga), og ekomloven paragraf 3-15 krever samtykke foer
 * de skrives. Sier den besoekende nei, finnes skriptet ikke i det hele tatt.
 *
 * Siden er en SPA, saa gtag teller bare den foerste visningen selv. Derfor
 * sendes page_view manuelt ved hvert rutebytte.
 */

const GA_ID = "G-1SLYNTC44S";

type GtagFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: GtagFn;
  }
}

let lastet = false;

/** Laster GA4. Trygg aa kalle flere ganger. Kalles kun etter samtykke. */
export function initGtag() {
  if (typeof window === "undefined" || lastet) return;
  lastet = true;

  // Skulle en Google Ads-tagg en dag legges paa siden, laster den allerede
  // gtag.js. Da skal vi bruke koeen som finnes, ikke lage en ny og overskrive
  // funksjonen deres.
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    const gtag: GtagFn = (...args) => {
      window.dataLayer!.push(args);
    };
    window.gtag = gtag;
    gtag("js", new Date());
  }

  if (
    !document.getElementById("ga4-gtag-js") &&
    !document.querySelector('script[src*="googletagmanager.com/gtag/js"]')
  ) {
    const script = document.createElement("script");
    script.id = "ga4-gtag-js";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
  }

  window.gtag?.("config", GA_ID);
}

/** Sidevisning ved rutebytte. Gjoer ingenting foer samtykke er gitt. */
export function trackGtagPageView(path: string) {
  if (typeof window === "undefined" || !lastet) return;
  window.gtag?.("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
